(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elimest-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGiant(root) {
      var giant = (root || document).querySelector('.e-footer__giant');
      if (!giant || giant.dataset.eReady) return;
      giant.dataset.eReady = '1';
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        giant.classList.add('is-visible');
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          giant.classList.add('is-visible');
          io.disconnect();
        }
      }, { threshold: 0.2 });
      io.observe(giant);
    }
    initGiant();
    document.addEventListener('shopify:section:load', function (e) { initGiant(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elimest-home-day"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-e-day]').forEach(function (day) {
        if (day.dataset.eReady || !('IntersectionObserver' in window)) return;
        day.dataset.eReady = '1';
        var steps = day.querySelectorAll('[data-e-step]');
        var frames = day.querySelectorAll('[data-e-frame]');
        function activate(i) {
          steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
          frames.forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
        }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) activate(parseInt(e.target.dataset.eStep, 10));
          });
        }, { rootMargin: '-45% 0px -45% 0px' });
        steps.forEach(function (s) { io.observe(s); });
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var step = e.target.closest && e.target.closest('[data-e-step]');
      if (!step) return;
      var day = step.closest('[data-e-day]');
      var i = parseInt(step.dataset.eStep, 10);
      day.querySelectorAll('[data-e-step]').forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      day.querySelectorAll('[data-e-frame]').forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elimest-home-posture"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // İki duruş: aynı sayı dizisi yapısı, ara değerler doğrusal hesaplanır
    var POSES = {
      spine: ['M214 292C188 268 172 234 174 196C176 166 196 144 228 132', 'M222 286C214 256 208 224 214 190C218 164 220 144 218 120'],
      arm: ['M228 150C268 172 310 194 448 204', 'M218 150C278 168 338 190 448 204'],
      legs: ['M214 292L378 292L388 398L414 398', 'M222 286L378 286L388 398L414 398'],
      neck: ['M232 134L262 128', 'M218 120L220 112'],
    };
    var HEAD = [[284, 124], [222, 84]];
    var num = /-?\d+(\.\d+)?/g;
    function lerpPath(a, b, t) {
      var nb = b.match(num);
      var i = 0;
      return a.replace(num, function (m) {
        var v = parseFloat(m) + (parseFloat(nb[i++]) - parseFloat(m)) * t;
        return v.toFixed(1);
      });
    }
    function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }

    function init(root) {
      (root || document).querySelectorAll('[data-e-posture]').forEach(function (stage) {
        if (stage.dataset.eReady) return;
        stage.dataset.eReady = '1';
        var section = stage.closest('.e-posture');
        var range = stage.querySelector('input[type=range]');
        var els = {};
        stage.querySelectorAll('[data-e-po]').forEach(function (el) { els[el.dataset.ePo] = el; });
        var legends = section.querySelectorAll('[data-e-po-legend]');

        function set(raw) {
          var t = Math.max(0, Math.min(1, raw));
          var k = ease(t);
          stage.style.setProperty('--t', k.toFixed(3));
          Object.keys(POSES).forEach(function (key) {
            if (els[key]) els[key].setAttribute('d', lerpPath(POSES[key][0], POSES[key][1], k));
          });
          if (els.head) {
            els.head.setAttribute('cx', (HEAD[0][0] + (HEAD[1][0] - HEAD[0][0]) * k).toFixed(1));
            els.head.setAttribute('cy', (HEAD[0][1] + (HEAD[1][1] - HEAD[0][1]) * k).toFixed(1));
          }
          range.setAttribute('aria-valuetext', t < 0.5 ? range.dataset.before : range.dataset.after);
          legends.forEach(function (l) {
            l.classList.toggle('is-on', (l.dataset.ePoLegend === 'after') === t >= 0.5);
          });
        }
        range.addEventListener('input', function () { set(range.value / 100); });
        set(range.value / 100);

        // Görünür olunca bir kez desteksizden ErgoPlus'a geçişi oynat
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            if (!entries[0].isIntersecting) return;
            io.disconnect();
            var start = null;
            var touched = false;
            range.addEventListener('pointerdown', function () { touched = true; }, { once: true });
            setTimeout(function () {
              requestAnimationFrame(function step(ts) {
                if (touched) return;
                if (!start) start = ts;
                var k = Math.min((ts - start) / 1800, 1);
                range.value = Math.round(k * 100);
                set(k);
                if (k < 1) requestAnimationFrame(step);
              });
            }, 500);
          }, { threshold: 0.55 });
          io.observe(stage);
        } else {
          range.value = 100;
          set(1);
        }
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elimest-home-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('.e-revs').forEach(function (sec) {
        if (sec.dataset.eReady) return;
        sec.dataset.eReady = '1';
        var rail = sec.querySelector('[data-e-rail]');
        var prev = sec.querySelector('[data-e-rail-prev]');
        var next = sec.querySelector('[data-e-rail-next]');
        if (!rail) return;
        function stepSize() {
          var card = rail.querySelector('.e-revs__card');
          return card ? card.getBoundingClientRect().width + 16 : 300;
        }
        function update() {
          prev.disabled = rail.scrollLeft < 4;
          next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
        }
        prev.addEventListener('click', function () { rail.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
        next.addEventListener('click', function () { rail.scrollBy({ left: stepSize(), behavior: 'smooth' }); });
        rail.addEventListener('scroll', update, { passive: true });
        update();
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elimest-home-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-e-route]').forEach(function (el) {
        if (el.dataset.eReady) return;
        el.dataset.eReady = '1';
        if (!('IntersectionObserver' in window)) { el.classList.add('is-visible'); return; }
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { el.classList.add('is-visible'); io.disconnect(); }
        }, { threshold: 0.4 });
        io.observe(el);
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elimest-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-e-prev]').forEach(function (sec) {
        if (sec.dataset.eReady) return;
        sec.dataset.eReady = '1';
        var btn = sec.querySelector('[data-e-prev-more]');
        var step = parseInt(sec.dataset.step, 10) || 6;
        if (btn) {
          btn.addEventListener('click', function () {
            var rest = sec.querySelectorAll('[data-e-more][hidden]');
            for (var i = 0; i < Math.min(step, rest.length); i++) rest[i].hidden = false;
            if (rest.length <= step) btn.hidden = true;
          });
        }
      });
      // Puan rozetinden yumuşak kaydırma (masaüstünde kaydırma .page-wrapper içinde)
      document.querySelectorAll('[data-e-scroll]').forEach(function (a) {
        if (a.dataset.eReady) return;
        a.dataset.eReady = '1';
        a.addEventListener('click', function (e) {
          var id = a.getAttribute('href').slice(1);
          var target = document.getElementById(id);
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elimest-product-size"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-e-size]').forEach(function (sec) {
        if (sec.dataset.eReady) return;
        sec.dataset.eReady = '1';
        var form = sec.querySelector('[data-e-size-form]');
        var out = sec.querySelector('[data-e-size-out]');
        var i18n = JSON.parse(sec.parentElement.querySelector('[data-e-size-i18n]').textContent);
        var need = parseFloat(sec.dataset.width);
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var v = parseFloat(form.querySelector('input').value);
          var state, msg;
          if (!v || v < 20 || v > 120) { state = 'invalid'; msg = i18n.invalid; }
          else if (v >= need) { state = 'ok'; msg = i18n.ok; }
          else if (v >= need - 5) { state = 'tight'; msg = i18n.tight; }
          else { state = 'small'; msg = i18n.small; }
          out.dataset.state = state;
          out.textContent = msg.replace('[olcu]', need).replace('[girilen]', v || '');
        });
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elimest-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-e-count]').forEach(function (el) {
        if (el.dataset.eReady) return;
        el.dataset.eReady = '1';
        var target = parseFloat(el.dataset.eCount);
        if (!target || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        var final = el.textContent;
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          var start = null;
          requestAnimationFrame(function step(t) {
            if (!start) start = t;
            var k = Math.min((t - start) / 1400, 1);
            el.textContent = Math.round(target * (1 - Math.pow(1 - k, 3)));
            if (k < 1) requestAnimationFrame(step); else el.textContent = final;
          });
        }, { threshold: 0.6 });
        io.observe(el);
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
